/**
 * Box 1 (spec §3.3): D2's SegmentCharts, unchanged, over every row of box 2 (all M, never the first 15): Share of
 * spend, CTR and CPC per family, in the order CORE · LAL · BROAD · RTG · Unclassified, a family under 500 impressions
 * left out of CTR and CPC with D2's line. It is in box 2's state: loading, failed with "ลองอีกครั้ง", box 2's empty line
 * (R9), or the charts.
 *
 * @module components/audience/AudienceSegments
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { SegmentCharts } from '@/components/channels/SegmentCharts';
import { BoxMessage } from '@/components/looker/app/appBoxShared';
import { OverviewBox } from '@/components/overview/OverviewBox';
import { emptyTextOf, type AppliedFilters } from '@/services/audience/audienceText';
import type { AudienceTableData } from '@/services/audience/audienceTypes';
import type { BoxState } from '@/services/overview/overviewTypes';

interface Props {
  state: BoxState<AudienceTableData>;
  /** The page currency (D1's choice); null until the facts are read. */
  currency: string | null;
  /** The workspace's name, or "ทุก workspace": the empty line names it (R9). */
  scope: string;
  filters: AppliedFilters;
  onRetry: () => void;
}

export const AudienceSegments: React.FC<Props> = ({ state, currency, scope, filters, onRetry }) => {
  const { t } = useTranslation();
  return (
    <OverviewBox id="1" title={t('audience.box.segments')} state={state} onRetry={onRetry}>
      {(data) => (data.rows.length === 0
        ? <BoxMessage text={emptyTextOf(data, scope, filters, t)} />
        : <SegmentCharts segments={data.segments} currency={currency} />)}
    </OverviewBox>
  );
};
